import { makeStyles } from "@material-ui/core/styles";

export const useStyles = makeStyles((theme) => ({
  root: {
    padding: theme.spacing(0, 2, 2),
  },
  sliderLabel: {
    display: "block",
    marginBottom: theme.spacing(0.5),
    color: theme.palette.text.primary,
  },
  sliderRow: {
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(2),
  },
  sliderValue: {
    minWidth: 20,
    textAlign: "center",
    fontWeight: 700,
  },
  exceptionRow: {
    marginTop: theme.spacing(0.5),
    marginBottom: theme.spacing(1.5),
  },
  progressWrap: {
    position: "relative",
    marginBottom: theme.spacing(1.5),
  },
  progressBar: {
    height: 20,
    borderRadius: 4,
  },
  progressText: {
    position: "absolute",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: 12,
    fontWeight: 700,
    color: theme.palette.text.primary,
  },
  buttonRow: {
    display: "flex",
    justifyContent: "center",
    gap: theme.spacing(1),
  },
}));
